import { Card, Stack } from '@mui/material';
import {
    BulkActionsToolbar,
    BulkDeleteButton,
    CreateButton,
    ListToolbar,
    Pagination,
    SortButton,
    Title,
    TopToolbar,
} from 'react-admin';
import { MissionListContent } from './MissionListContent';
import { MissionListFilter } from './MissionListFilter';
import { AntennaId, MemberId } from '@wwf/sdk';

interface MissionListLayoutProps {
    antennaId?: AntennaId;
    memberId?: MemberId;
    disableSaveQuery?: boolean;
    /** When the list uses an RPC (e.g. mission_by_member), hide filters so PostgREST only gets RPC args. */
    hideFilters?: boolean;
    hideBulkActions?: boolean;
}

export const MissionListLayout = ({
    antennaId,
    memberId,
    disableSaveQuery,
    hideFilters,
    hideBulkActions,
}: MissionListLayoutProps) => {
    return (
        <Stack direction="row">
            {hideFilters ? null : (
                <MissionListFilter
                    disableSaveQuery={disableSaveQuery}
                    sx={{ mt: 2 }}
                    showDateFilters
                    disableAntennaFilter={antennaId !== undefined}
                />
            )}
            <Stack sx={{ width: '100%' }}>
                <Title title={'mission'} />
                <ListToolbar
                    actions={
                        <MissionListActions
                            antennaId={antennaId}
                            memberId={memberId}
                        />
                    }
                />
                {hideBulkActions ? null : (
                    <BulkActionsToolbar>
                        {/* <BulkExportButton exporter={missionExporter} /> */}
                        <BulkDeleteButton />
                    </BulkActionsToolbar>
                )}
                <Card>
                    <MissionListContent
                        memberId={memberId}
                        noBulkActions={hideBulkActions}
                    />
                </Card>
                <Pagination rowsPerPageOptions={[10, 25, 50, 100]} />
            </Stack>
        </Stack>
    );
};

const MissionListActions = ({
    antennaId,
    memberId,
}: {
    antennaId?: AntennaId;
    memberId?: MemberId;
}) => (
    <TopToolbar>
        <SortButton fields={['name', 'updatedAt', 'startDate']} />
        {/* <ExportButton exporter={missionExporter} /> */}
        <CreateButton
            variant="contained"
            resource="mission"
            label="New Mission"
            sx={{ marginLeft: 2 }}
            state={{ antennaId, memberId }}
        />
    </TopToolbar>
);
